import { FetchError } from '@api/client';

import { notifyUnauthorized } from '../model';

import { ERRORS } from './constants';
import type { AnyServiceError, ErrorCode, ServiceError } from './types';

export const handleServiceErrorCode = <T extends ErrorCode>(
  error: unknown,
  code: T,
  callback?: (errorData: ServiceError<T>) => void,
): boolean => {
  if (error instanceof FetchError) {
    const errorData = error.response as ServiceError;

    if (errorData && errorData.code === code) {
      if (callback) callback(errorData as ServiceError<T>);
      return true;
    }
  }

  return false;
};

export const handleServiceError = (
  error: unknown,
  callback?: (errorData: AnyServiceError) => void,
): boolean => {
  if (error instanceof FetchError) {
    const errorData = error.response as AnyServiceError;

    if (errorData) {
      if (callback) callback(errorData as AnyServiceError);
      return true;
    }
  }

  return false;
};

export const handleUnauthorizedError = (error: unknown): boolean => {
  return handleServiceErrorCode(
    error,
    ERRORS.CODE_UNAUTHENTICATED,
    notifyUnauthorized,
  );
};
